var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHd(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "43px",
    height: "43px",
    viewBox: "0 0 43 43",
    style: {
      enableBackground: "new 0 0 43 43"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.0887,4.6712h-25c-0.345,0-0.625,0.28-0.625,0.625v32.5c0,0.3456,0.28,0.625,0.625,0.625h25 c0.3456,0,0.625-0.2794,0.625-0.625v-32.5C34.7137,4.9512,34.4344,4.6712,34.0887,4.6712z M33.4637,37.1712h-23.75v-31.25h23.75 V37.1712z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.2712,25.48l-2.4994,2.4994c-0.1175,0.1169-0.1831,0.2756-0.1831,0.4419v3.75 c0,0.3456,0.28,0.625,0.625,0.625c0.345,0,0.625-0.2794,0.625-0.625V28.68l2.3919-2.3912 c1.775,1.3325,3.9725,2.1325,6.3581,2.1325c5.8587,0,10.625-4.7662,10.625-10.625s-4.7663-10.625-10.625-10.625 s-10.625,4.7663-10.625,10.625C10.9637,20.8187,12.2387,23.5437,14.2712,25.48z M21.5887,8.4212 c5.1694,0,9.375,4.2056,9.375,9.375s-4.2056,9.375-9.375,9.375c-2.0413,0-3.9256-0.6631-5.4669-1.7744l2.7838-2.7838 c0.2444-0.2444,0.2444-0.6394,0-0.8838c-0.2444-0.2444-0.6394-0.2444-0.8838,0l-2.8675,2.8675 c-1.8063-1.71-2.9406-4.1225-2.9406-6.8006C12.2137,12.6269,16.4193,8.4212,21.5887,8.4212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.5887,20.9212c1.7231,0,3.125-1.4019,3.125-3.125c0-1.7231-1.4019-3.125-3.125-3.125 c-1.7231,0-3.125,1.4019-3.125,3.125C18.4637,19.5194,19.8656,20.9212,21.5887,20.9212z M21.5887,15.9212 c1.0337,0,1.875,0.8413,1.875,1.875c0,1.0338-0.8413,1.875-1.875,1.875c-1.0338,0-1.875-0.8412-1.875-1.875 C19.7137,16.7625,20.555,15.9212,21.5887,15.9212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12.2137,
    cy: 34.6712,
    r: 0.625
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 30.9637,
    cy: 34.6712,
    r: 0.625
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12.2137,
    cy: 8.4212,
    r: 0.625
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 30.9637,
    cy: 8.4212,
    r: 0.625
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHd);
export default __webpack_public_path__ + "static/media/icon-hd.59bef73cee65a484f4c8ec46e2dc80e1.svg";
export { ForwardRef as ReactComponent };